import '~/components/cx/CxEditor/CxEditor.plugin';
import CxTooltip from '~/components/cx/CxTooltip/CxTooltip.plugin';

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.use(CxTooltip);
});
